import axios from "axios";
import {config} from "../helpers/config";

const http = axios.create({
  baseURL: config.storakAuthApiUrl,
});

export default http;
